import styled from 'styled-components';

export const StyledSummaryWrapper = styled.div`
    width: 100%;
    margin-top: 20px;
`;
